import React from "react";
import CatalogoPageLayout from "./CatalogoPageLayout";

const CatalogoCocinasPage: React.FC = () => (
  <CatalogoPageLayout
    title="Cocinas y KDS"
    description="Definí las zonas de producción, impresoras de comanda y pantallas KDS por sucursal."
    helperText="Próximamente vas a poder asignar artículos a cada estación de trabajo y monitorear su estado."
  />
);

export default CatalogoCocinasPage;
